import { render, staticRenderFns } from "./OrderRoundProducers.vue?vue&type=template&id=37ce8e15&"
import script from "./OrderRoundProducers.vue?vue&type=script&lang=js&"
export * from "./OrderRoundProducers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports